import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { Auth, API } from "aws-amplify";
import { onError } from "../libs/errorLib";
import { formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import AdminLeftMenu from "./AdminLeftMenu";
import BasicDomainItems from "./BasicDomainItems";
import ExpertDomainItems from "./ExpertDomainItems";
import MemberTypeItemNames from "./MemberTypeItemNames";
import "./Admin.css";
import "../admin.css";

export default function AdminAnnualFees() {
  const search = useLocation().search;
  const qPage = new URLSearchParams(search).get('page'); // page
  console.log('qPage = ' + qPage);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1);

  const [fees, setFees] = useState([]);
  const history = useHistory();

  const [refreshCounter, setRefreshCounter] = useState(0);
  const [checks, setChecks] = useState([]);
  const [selectAll, setSelectAll] = useState(0);

  const today = new Date();
  const [sYearOfFee, setSYearOfFee] = useState('2026');

  let year = new URLSearchParams(search).get('y');
  if (!year) year = "2020";

  const [pageLimit, setPageLimit] = useState("50");

  useEffect(() => {
    console.log('useEffect called...');
    const onLoad = async () => {
      try {
        console.log('onLoad called...');
        const anonymousUser = await Auth.currentCredentials();
        console.log(anonymousUser);
        const fc = await loadFees(false);
        setTotal(fc);
        console.log('CountFees : ' + fc);
        const fs = await loadFees(true);
        console.log(fs);
        console.log('onLoad fees length: ' + fs.length);
        setFees(fs);
        console.log('currentPage: ' + currentPage);
        const n = parseInt (fc / pageLimit) + (fc % pageLimit > 0 ? 1 : 0);
        console.log('page count: ' + n);

        let ps = [];
        console.log('currentPage: ' + currentPage);
        const maxp = 4 + parseInt(currentPage);
        console.log(`n=${n}, currentPage=${currentPage}, maxp=${maxp}`);
        var pnc = 0; //page num count
        var leftMost = false;
        var inTheMiddle = false;
        var rightMost = false;
        if (n > 9 && currentPage > 5) {
            ps.push({"label": '<<'});
        }
        for(let i=0; i < 9; i++) {
          if (currentPage <= 5) {
            if (!leftMost) {
              pnc = 0;
              leftMost = true;
            }
          } else if(currentPage > (n - 9) && !rightMost) {
            if (!rightMost) {
              pnc = currentPage - 9;
              rightMost = true;
            }
          } else {
            if (!inTheMiddle) {
               pnc = parseInt(currentPage) - 5;
              inTheMiddle = true;
            }
	  }
          pnc++;
          console.log('pnc: ' + pnc);
          ps.push({"label": /*i+1*/pnc});
        }
        if (n > maxp) {
          ps.push({"label": '>>'});
        }
        console.log('onLoad()........ps');
        console.log(ps);
        setPages(ps);
        const l = fs.length < pageLimit ? fs.length : pageLimit;
        setChecks(new Array(l));
      } catch (e) {
        onError(e);
      }
    };
    onLoad();
  },[refreshCounter]);

  function loadFees(isLoad) {
    console.log('loadFees...');
    let p = `ob=${fields.ascOrDesc}&of=${fields.orderBy}&cp=${currentPage}&pl=${pageLimit}`;
    p += `&y=${sYearOfFee}`;

    let isMNumFilterd = false;
    if (fields.mNumBegin) {
      p += `&bn=${fields.mNumBegin}`;
      isMNumFilterd = true;
    }
    if (fields.mNumEnd) {
      p += `&en=${fields.mNumEnd}`;
      isMNumFilterd = true;
    }
    if (fields.mName)
      p += `&na=${fields.mName}`;
    if (mAnnualFees[0] == 0 && mAnnualFees[1] == 1) {
      p += `&af=1`;
    } else if (mAnnualFees[0] == 1 && mAnnualFees[1] == 0) {
      p += `&af=0`;
    }
    if (fields.mAffiliationName)
      p += `&afn=${fields.mAffiliationName}`;
    const path = isLoad ? `/fees?${p}` : `/countFees?${p}`;
    console.log(path);
    const fs = API.get("sakurajima", path);
    return fs;
  }

  const { userProfile } = useAppContext();

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    mNumBegin: "",
    mNumEnd: "",
    mName:"",
    mAffiliationName: "",
    orderBy: "1",
    ascOrDesc: "1",
    updateStatus: "0",
  },
  {
    mNumBegin: {n:"", f: (value) => { return '' }},
    mNumEnd: {n:"", f: (value) => { return '' }},
    mName: {n:"", f: (value) => { return '' }},
    mAffiliationName: {n:"", f: (value) => { return '' }},
    orderBy: {n:"", f: (value) => {  return '' }},
    ascOrDesc: {n:"", f: (value) => { return '' }},
    updateStatus: {n:"", f: (value) => { return '' }},
  });

  // mAnnualFees checkbox
  const [mAnnualFees, setMAnnualFees] = useState([0,0]);
  const [total, setTotal] = useState(0);

  async function handleSearch(event) {
    console.log('handleSearch...');
    console.log(fields.orderBy);
    console.log(fields.ascOrDesc);
    try {
      const fc = await loadFees(false);
      console.log('seaarch fees count: ' + fc);
      setTotal(fc);
      const fs = await loadFees(true); 
      console.log('search fees length:' + fs.length);
      setFees(fs);
      const n = parseInt (fc / pageLimit) + ( fc % pageLimit > 0 ? 1 : 0);
      console.log('page num: ' + n);
      let ps = [];
      console.log('currentPage: ' + currentPage);
      var pnc = 0; //page num count
      var showLeft = false;
      for(let i=0; i < n; i++) {
        if (n > 9) {
          if (i < currentPage-1) continue;
          if (currentPage > 1 && !showLeft) { ps.push({"label": '<<'}); showLeft = true; }
	}
        pnc++;
        ps.push({"label": i+1});
        if (pnc > 9) {
          ps.push({"label": '>>'});
          break;
        }
      }
      console.log(ps);
      setPages(ps);
      const l = fs.length < pageLimit ? fs.length : pageLimit;
      setChecks(new Array(l));
    } catch (e) {
      onError(e);
    }
  }

  function handleView(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/members/${pk}?vm=af`); // view mode is Admin Fees
  }

  function handleViewReports(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    const i = e.target.getAttribute('keyIndex');
    console.log('i = ' + i);
    console.log('pk = ' + pk);
    const ar = pk.split('#');
    history.push(`/admin/reports?mid=${ar[0]}`);
  }

  function handleEdit(e) {
    e.preventDefault();
    const pk = e.target.getAttribute('pk');
    history.push(`/editMembers/${pk}`);
  }

  function handleMAnnualFeesChange(event) {
    console.log('handleMAnnualFeesChange..');
    const n = event.target.name;
    const i = parseInt(n.substring('mAnnualFees'.length));
    let chs = JSON.parse(JSON.stringify(mAnnualFees));
    chs[i] = event.target.checked ? 1 : 0;
    console.log(chs);
    setMAnnualFees(chs);
  }

  function handleClear(evenat) {
    console.log('handleClear...');
//    setMStatus([0,0,0,0,0]);

    fields.mNumBegin = '';
    fields.mNumEnd = '';
    fields.mName = "";
    fields.mAffiliationName = "";
    setMAnnualFees([0,0]);
    const today = new Date();
//    setSYearOfFee(today.getFullYear());
    setSYearOfFee('2025');
    fields.orderBy = "1";
    fields.ascOrDesc = "1";
    setPageLimit("50");
    setRefreshCounter(refreshCounter+1);
  }

  const getStatusName = (state) => {
      if (1 == state)
	  return '入金済';
      else
	  return '未入金';
  };

  const getMemberId = (data) => {
//    const d = data.split('#');
//    return d[1];
      return data.memberId;
  };

  const handleItemCheckChanged = (e) => {
    console.log('handleItemCheckChanged...');
    let chs = JSON.parse(JSON.stringify(checks));
    console.log(chs);
    if ('selectAll' === e.target.name) {
      for(let i=0; checks.length > i; i++) {
        chs[i] = e.target.checked ? 1 : 0;
        setChecks(chs);
      }
      setSelectAll(e.target.checked ? 1 : 0);
      return;
    }
    console.log(e.target.value);
    setSelectAll(0);
    chs[e.target.value] = e.target.checked ? 1 : 0;
    setChecks(chs);
  };

  const handlePageChanged = async (e) => {
    console.log('handlePageChanged=>' + e.target.value);
    //handleFieldChange(e);
    setPageLimit(e.target.value);
    const n = parseInt (fees.length / e.target.value)+1;
    console.log(n);
    let ps = [];
    for(let i=0; i < n; i++) ps.push({"label": i+1});
    console.log(ps);
    setPages(ps);
  };

  const pageClickAction = (e) => {
    e.preventDefault();
    setSelectAll(0);
    console.log('pageClick');
    console.log(e.target.href.split('#'));
    const idxLabel = e.target.href.split('#')[1];
    var curp = "1";
    console.log(parseInt(currentPage) + 5);
    if (idxLabel == '>>' || idxLabel== '%3E%3E')
	curp = (parseInt(currentPage) + 10).toString();
    else if (idxLabel == '<<' || idxLabel == '%3C%3C')
	curp = ((parseInt(currentPage) - 10) > 0 ? (parseInt(currentPage) - 10) : 1).toString();
    else 
      curp = idxLabel;
    console.log(typeof curp);
//    const curp = e.target.href.split('#')[1];
//    setChecksOnPage(mmembers, pageLimit, curp);
    setCurrentPage(curp);
    setRefreshCounter(refreshCounter+1);
    return false;
  };

  function updateAnnualFeeStatus(statuses) {
    console.log(statuses);
    return API.put("sakurajima", "/annualFeeStatuses", {
	body: statuses
    });
  }

  return (
    <div className="Admin">
      <h1 id="page_title">管理者用　年会費管理</h1>
      <div className="container">
        <div id="sub_page">
          <div id="admin" className="top">
              <AdminLeftMenu />
              <section id="contents" className="top">
                <h2>年会費管理</h2>
                <div id="search">
                  <h3>検索条件</h3>
                  <Table>
                    <tbody>
                      <tr>
                        <th>会員番号</th>
                        <td>
                          <Form.Group controlId="mNumBegin" className="inlineFormControl" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mNumBegin}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                          
                          <Form.Group controlId="mNumEnd" className="glbHidden inlineFormControl" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mNumEnd}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>氏名</th>
                        <td>
                          <Form.Group controlId="mName" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mName}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>所属</th>
                        <td>
                          <Form.Group controlId="mAffiliationName" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.mAffiliationName}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>年会費</th>
                        <td>
                          <Form.Group className="inlineFormControl">
                            <Form.Check
                              inline
                              id="mAnnualFees0"
                              name="mAnnualFees0"
                              label="未入金"
                              type="checkbox"
                              value="1"
                              checked={ 1 == mAnnualFees[0] }
                              onChange={handleMAnnualFeesChange}
                              className="inlineFormControl"
                            />
                            <Form.Check
                              inline
                              id="mAnnualFees1"
                              name="mAnnualFees1"
                              label="入金済"
                              type="checkbox"
                              value="1"
                              checked={ 1 == mAnnualFees[1] }
                              onChange={handleMAnnualFeesChange}
                              className="inlineFormControl"
                            />
                          </Form.Group>
                          <Form.Group className="inlineFormSelect inlineFormControl selectYmd" controlId="sYearOfFee" size="lg">
                            <Form.Control
                              as="select"
                              custom
                              className="selectYmd"
                              size="sm"
                              name="sYearOfFee"
                              value={sYearOfFee}
                              onChange={ (e) => setSYearOfFee(e.target.value) }
                            >
                              <option value="2005">2005</option>
                              <option value="2006">2006</option>
                              <option value="2007">2007</option>
                              <option value="2008">2008</option>
                              <option value="2009">2009</option>
                              <option value="2010">2010</option>
                              <option value="2011">2011</option>
                              <option value="2012">2012</option>
                              <option value="2013">2013</option>
                              <option value="2014">2014</option>
                              <option value="2015">2015</option>
                              <option value="2016">2016</option>
                              <option value="2017">2017</option>
                              <option value="2018">2018</option>
                              <option value="2019">2019</option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                              <option value="2027">2027</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>ソート順</th>
                        <td>
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="orderBy" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="orderBy"
                              value={fields.orderBy}
                              onChange={handleFieldChange}
                            >
                              <option value="1">会員番号</option>
                              <option value="2">入金日</option>
                            </Form.Control>
                          </Form.Group>
                          の
                          <Form.Group className="inlineFormSelect inlineFormControl" controlId="ascOrDesc" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="ascOrDesc"
                              value={fields.ascOrDescy}
                              onChange={handleFieldChange}
                            >
                              <option value="1">降順</option>
                              <option value="2">昇順</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <th>表示件数</th>
                        <td>
                          <Form.Group className="" controlId="pageLimit" size="sm">
                            <Form.Control
                              as="select"
                              custom
                              size="sm"
                              name="pageLimit"
                              value={pageLimit}
                              onChange={handlePageChanged}
                            >
                              <option value="10">10</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                            </Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="search_btn">
                    <Button id="searchBtn" active size="sm" active onClick={ handleSearch }>検索</Button>
                    <Button id="resetBtn" active size="sm" active onClick={ handleClear }>検索条件クリア</Button>
                 </div>
                </div>
               <div id="list">
                 <h3>リスト一覧</h3>
　　　            <p>{ parseInt(pageLimit)*(currentPage-1)+1 } - { parseInt(pageLimit)*(currentPage) }を表示中：ページ{currentPage} (全<b>{ total }</b>件中)</p>
                 <Table>
                   <tbody>
                     <tr>
                       <th className="admHidden">
                            <Form.Check
                              inline
                              type="checkbox"
                              name="selectAll"
                              value="1"
                              checked={ 1 == selectAll }
                              onChange={handleItemCheckChanged}
                            />
                       </th>
                       <th>会員番号</th>
                       <th>氏　名</th>
                       <th>所　属</th>
                       <th>納入状況</th>
                       <th>入金日</th>
                       <th>会員種別</th>
                 {/*   <th>入会日</th> */}
                       <th>処理</th>
                     </tr>
                     <tr>
                     </tr>
          {fees.map(({pk,sk,data, familyName, givenName, affiliationName, status, dateOfPayment, admissionDate, memType, memberId}, index) => (
                     <tr>
                       <td className="admHidden">
                            <Form.Check
                              inline
                              type="checkbox"
                              name="memItem"
                              value={index}
                              checked={1 == checks[index]}                   
                              onChange={handleItemCheckChanged}
                            />
                       </td>
                       <td>
                  { memberId == 'NotAssignedYet' ? '' : memberId }
                       </td>
                       <td>
                  {familyName} {givenName}
                       </td>
                       <td>
                  { affiliationName }
                       </td>
                       <td>
                  { getAnnualFeeStatusName(status) }
                       </td>
                       <td>
                  { 0 == status ? "" : dateOfPayment == 'HaveNotMadeAPayment' ? '' : dateOfPayment }
                       </td>
                       <td>
		  {  MemberTypeItemNames[memType] }
                       </td>
		  {/*                <td>
                  { admissionDate }
                  </td> */}
                       <td>
                  <Button id="editfBtn" pk={ pk } keyIndex={ index }  active size="sm" active onClick={ handleViewReports }>納入状況</Button>
                       </td>
                  </tr>
                     ))}
                   </tbody>
                 </Table>
                 <div className="pageswitch">
                    <ul>
          { pages.map(({label}, index) => (
		  <li className={(currentPage == label) ? 'active' : ''}><Nav.Link href={ "#" + label} onClick={pageClickAction}>{label}</Nav.Link></li>
	  ))}
                    </ul>
                  </div>
               </div>
              </section>
          </div>
        </div>
      </div>
    </div>
  );
}
